import { Avatar } from '@mui/material';

import { TruncatedText } from 'src/components/TruncatedText';

interface SidebarLogoProps {
  /** Logo background color to use when no workspace logo is provided */
  iconFallbackBGColor: string;
  /** Number of characters to display before truncation */
  maxChars?: number;
  /** Text color for the sidebar */
  sidebarTextColor: string;
  /** URL of the workspace logo image */
  workspaceLogoURL: string | undefined;
  /** Name of the workspace */
  workspaceName: string;
}

export const SidebarLogo = ({
  iconFallbackBGColor,
  maxChars = 16.5,
  sidebarTextColor,
  workspaceLogoURL,
  workspaceName,
}: SidebarLogoProps) => (
  <div className="flex items-center w-full">
    <Avatar
      variant="rounded"
      className={
        'w-[25px] h-[25px] mr-2 rounded text-[15px] leading-6 font-medium' +
        (workspaceLogoURL
          ? 'bg-transparent'
          : 'flex items-center justify-center')
      }
      style={{
        backgroundColor: !workspaceLogoURL
          ? iconFallbackBGColor
          : 'transparent',
      }}
    >
      {workspaceLogoURL ? (
        <img className="w-full" src={workspaceLogoURL} alt="Logo" />
      ) : (
        <div>{workspaceName.split('')[0]}</div>
      )}
    </Avatar>

    <TruncatedText
      className="text-[13px] leading-6 font-medium"
      showTitle
      styleProps={{ color: sidebarTextColor }}
      text={workspaceName}
      maxChars={maxChars}
    />
  </div>
);
